import { Controller } from '@hotwired/stimulus'

// Email Validation Controller
//
// Handles AJAX response for validating email addresses
export default class extends Controller {
  static targets = ['input', 'result', 'wrapper']
  static values = {
    'url': String
  }

  async fetchValidationResults () {
    if (this.wrapperTarget.classList.contains("has-error")) { return; }

    const email = this.inputTarget.value

    const response = await fetch(this.urlValue, {
      method: 'POST',
      body: new URLSearchParams({ email: email }),
    })

    if (response.status == 200) {
      // ok
    } else if (response.status == 422) {
      // invalid
      const html = await response.text()
      this.showResult(html)
      this.markWrapperAsInvalid()
    } else {
      // error
    }
  }

  markWrapperAsInvalid () {
    if (this.hasWrapperTarget) {
      this.wrapperTarget.classList.add('has-error')
      this.wrapperTarget.classList.remove('valid-input')
    }
  }

  markWrapperAsValid () {
    if (this.hasWrapperTarget) {
      this.wrapperTarget.classList.remove('has-error')
      this.wrapperTarget.classList.add('valid-input')
    }
  }

  removeExistingValidationMessages () {
    this.element.querySelectorAll('.help-block.invalid-feedback').forEach(el => el.remove())
  }

  showResult (html) {
    if (this.hasResultTarget) {
      this.removeExistingValidationMessages()
      this.resultTarget.innerHTML = html
    }
  }

  useSuggestion (event) {
    const suggestion = event.target.dataset.suggestion
    if (suggestion) {
      this.inputTarget.value = suggestion
      this.resultTarget.innerHTML = ''
      this.markWrapperAsValid()
    }
  }
}
